export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/72a061e4da900bb3a21b7904c48e0b41.svg";